import { Navigate, NavigateProps } from 'react-router-dom'

import { usePrepareToProps } from './prepare-to-props'

const AppNavigate = (props: NavigateProps) => <Navigate {...props} to={usePrepareToProps(props.to)} />

export default AppNavigate
